import * as React from "react";
import { Alert } from "antd";
import { BillingAccount, BillingUserRole } from "../../../schema/types/account";
import { Link, Navigate } from "react-router-dom";
import { DOCS_URL } from "../../../envVariables";
import { ExternalLink } from "../../../newcomponents/table/components/ExternalLink";

const CreateOrg: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Link className="color-link" to={`/home/org/-create`}>
      {children}
    </Link>
  );
};

interface InviteUsersProps extends React.PropsWithChildren {
  accountId: string;
}
const InviteUsers: React.FC<InviteUsersProps> = ({ accountId, children }) => {
  return (
    <Link className="color-link" to={`/home/account/${accountId}/users`}>
      {children}
    </Link>
  );
};

interface Props {
  account: BillingAccount;
  roles: BillingUserRole[];
}
export const AccountDetailSetupCreateOrg: React.FC<Props> = ({ account, roles }) => {
  if (!roles.includes("org_creator") && !roles.includes("billing_admin")) {
    return <Navigate to={``} />;
  }

  return (
    <div className="mb-10">
      {account.enabled === false ? (
        <Alert
          type={`info`}
          message={`Info`}
          description={
            <div>
              Your account is not activated yet. Please wait until customer support enables your account, or contact
              support at{" "}
              <a className="color-link" href={"mailto:support@controlplane.com"}>
                support@controlplane.com
              </a>{" "}
              if you need further help.
            </div>
          }
        />
      ) : null}
      <div className="text-2xl mb-2">
        <span>Start by </span>
        <CreateOrg>creating an org</CreateOrg>
        {roles.includes("billing_admin") ? (
          <>
            <span> or </span>
            <InviteUsers accountId={account.id}>inviting users</InviteUsers>
            <span>
              {" "}
              who can create{" "}
              <ExternalLink url={`${DOCS_URL}/concepts/org`} label="org(s)" disableCopy />
            </span>
          </>
        ) : null}
        <span>.</span>
      </div>
    </div>
  );
};
